import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { BookMonth } from "@modules/bookMonths/types";

import { editBookMonthService } from "./service";
import { EditBookMonthPayload, UseEditBookMonthMutationOptions } from "./types";

export function useEditBookMonthMutation(options?: UseEditBookMonthMutationOptions) {
  const { open } = useNotification();

  return useMutation<BookMonth, ApiError, EditBookMonthPayload>({
    mutationFn: ({ id, data }) => editBookMonthService(id, data),
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response?.data?.error ?? "Erro ao editar período",
      });
    },
    ...options,
  });
}
